// 产品对比tab
import { useMemo, useImperativeHandle, forwardRef } from 'react';
import {
  AnalysisSpecComp,
  BasicInfoComp,
  PerformanceComparison,
  PositionAnalysis,
  RiskAssessmentComparison
} from '../ProductComparisonTab/index';
import ActionBar from '@/components/SelectSend';
import { useCheckboxGroup } from '@/hooks/useSelectCheck';
import useCopilotValueStore from '@/stores/copilotValueStore';
interface ProductComparisonRef {
  resetSelectedValues: () => void;
}
const ProductComparison = forwardRef<ProductComparisonRef, {}>((_props, ref) => {
  const { copilotValue9 } = useCopilotValueStore();

  const loading = useMemo(() => copilotValue9.loading, [copilotValue9.loading]);

  const totalData = useMemo(() => copilotValue9, [copilotValue9]);

  const {
    selectedValues,
    setSelectedValues,
    handleSelectChange,
    handleSelectAll,
    isAllSelected,
    isIndeterminate
  } = useCheckboxGroup({
    basicInfo: false,
    performanceComparison: false,
    riskAssessmentComparison: false,
    positionAnalysis: false
  });

  const resetSelectedValues = () => {
    setSelectedValues({
      basicInfo: false,
      performanceComparison: false,
      riskAssessmentComparison: false,
      positionAnalysis: false
    });
  };

  useImperativeHandle(ref, () => ({
    resetSelectedValues
  }));

  if (loading) {
    return (
      <div className="min-h-[200px] text-center text-sm text-black">
        Ai已识别客户投顾需求，正在检索市场行情数据生成完整洞察内容，请稍后…
      </div>
    );
  }
  return (
    <>
      <div className="h-full w-full pb-[56px]" id="productComparison-tab-page">
        {/* 基金产品深度 对比分析专业对比 */}
        <AnalysisSpecComp totalData={totalData} />
        {/* 基础信息对比 */}
        <BasicInfoComp
          totalData={totalData}
          selected={selectedValues.basicInfo}
          selectChange={handleSelectChange}
          type="basicInfo"
        />
        {/* 收益表现对比 */}
        <PerformanceComparison
          totalData={totalData}
          selected={selectedValues.performanceComparison}
          selectChange={handleSelectChange}
          type="performanceComparison"
        />
        {/* 风险评估对比 */}
        <RiskAssessmentComparison
          totalData={totalData}
          selected={selectedValues.riskAssessmentComparison}
          selectChange={handleSelectChange}
          type="riskAssessmentComparison"
        />
        {/* 持仓穿透分析 */}
        <PositionAnalysis
          totalData={totalData}
          selected={selectedValues.positionAnalysis}
          selectChange={handleSelectChange}
          type="positionAnalysis"
        />
      </div>
      {/* 操作栏 */}
      <ActionBar
        selectAll={isAllSelected}
        isIndeterminate={isIndeterminate}
        onUpdateSelectAll={handleSelectAll}
        selectedMetrics={selectedValues}
        tabType="productComparison"
        isFixed={true}
      />
    </>
  );
});

export default ProductComparison;
